module.exports = __webpack_public_path__ + "img/12.c3580221.png";